export default "__VITE_ASSET__1fa5c24e__"